import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,{style:({ background: this.$constants.backgroundColor })},[_c('router-view',{staticStyle:{"height":"100%","width":"100%","overflow":"auto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }